import { render, staticRenderFns } from "./ConnectWalletNetworkBadge.vue?vue&type=template&id=ad384698"
import script from "./ConnectWalletNetworkBadge.vue?vue&type=script&lang=ts"
export * from "./ConnectWalletNetworkBadge.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports